module.exports = __webpack_public_path__ + "static/media/limit.6a042fda.png";